import styled from '@emotion/styled';
import { Tag } from 'antd';

export const BlueTag = styled(Tag)`
  color: #336fff;
  border: solid 1px;
  border-color: #336fff;
  background: none;
`;

export const GreenTag = styled(Tag)`
  border: solid 1px;
  color: #4aaf4e;
  border-color: #4aaf4e;
  background: none;
`;

export const BlackTag = styled(Tag)`
  border: solid 1px;
  color: #141514;
  border-color: #d0d0d0;
  background: none;
`;

export const RedTag = styled(Tag)`
  border: solid 1px;
  color: #f05b5b;
  border-color: #f05b5b;
  background: none;
`;
